// extracted by mini-css-extract-plugin
export default {"hoverPanel":"H7nZFE","buttons":"wRgZ6H","editBtn":"PoGUW7","previewBtn":"h1ABYt","button":"eKP6KR","newEdit":"NKwyfQ","showInfo":"oRB7in","searchFadeIn":"Nt478e"};